import React from "react";
import { X, GraduationCap, Users } from "lucide-react";
import { motion } from "framer-motion";

export default function CertificateRequestTypePickerModal({
  isOpen,
  onClose,
  canStudent,
  canTeacher,
  onPickStudent,
  onPickTeacher,
}) {
  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[115] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.96, y: 12 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full max-w-md rounded-[1.75rem] shadow-xl overflow-hidden relative z-[120]"
      >
        <div className="px-6 py-5 border-b border-gray-100 flex items-start justify-between gap-3">
          <div>
            <h2 className="text-lg font-black text-gray-800 uppercase tracking-tight">
              Loại <span className="text-red-700">yêu cầu</span>
            </h2>
            <p className="text-gray-400 text-[11px] font-bold uppercase tracking-widest mt-1">
              Chọn đối tượng nhận chứng nhận
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full text-gray-400"
            aria-label="Đóng"
          >
            <X size={20} />
          </button>
        </div>

        <div className="p-5 space-y-3">
          <button
            type="button"
            disabled={!canStudent}
            onClick={() => {
              if (!canStudent) return;
              onPickStudent?.();
            }}
            className={`w-full flex items-start gap-4 rounded-2xl border-2 px-4 py-4 text-left transition-all ${
              canStudent
                ? "border-gray-100 hover:border-red-400 hover:bg-red-50/50 active:scale-[0.99]"
                : "border-gray-50 opacity-60 cursor-not-allowed bg-gray-50"
            }`}
          >
            <div
              className={`shrink-0 w-11 h-11 rounded-xl flex items-center justify-center ${
                canStudent ? "bg-red-100 text-red-700" : "bg-gray-100 text-gray-400"
              }`}
            >
              <GraduationCap size={22} strokeWidth={2.25} />
            </div>
            <div className="min-w-0">
              <div className="text-sm font-black text-gray-800 uppercase tracking-wide">Học viên</div>
              <div className="text-xs text-gray-500 font-semibold mt-0.5">
                Theo lớp và kết quả học tập
              </div>
              {!canStudent ? (
                <div className="text-[10px] font-bold text-amber-600 mt-2 uppercase tracking-wide">
                  Cần quyền elearning.certificates.student (C)
                </div>
              ) : null}
            </div>
          </button>

          <button
            type="button"
            disabled={!canTeacher}
            onClick={() => {
              if (!canTeacher) return;
              onPickTeacher?.();
            }}
            className={`w-full flex items-start gap-4 rounded-2xl border-2 px-4 py-4 text-left transition-all ${
              canTeacher
                ? "border-gray-100 hover:border-red-400 hover:bg-red-50/50 active:scale-[0.99]"
                : "border-gray-50 opacity-60 cursor-not-allowed bg-gray-50"
            }`}
          >
            <div
              className={`shrink-0 w-11 h-11 rounded-xl flex items-center justify-center ${
                canTeacher ? "bg-emerald-100 text-emerald-800" : "bg-gray-100 text-gray-400"
              }`}
            >
              <Users size={20} strokeWidth={2.25} />
            </div>
            <div className="min-w-0">
              <div className="text-sm font-black text-gray-800 uppercase tracking-wide">Giáo viên</div>
              <div className="text-xs text-gray-500 font-semibold mt-0.5">
                Upload Excel danh sách nhân viên / giảng viên
              </div>
              {!canTeacher ? (
                <div className="text-[10px] font-bold text-amber-600 mt-2 uppercase tracking-wide">
                  Cần quyền elearning.certificates.teacher (C)
                </div>
              ) : null}
            </div>
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
